import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {

    @Input() icon:string        = "";
    @Input() color:string       = "";
    @Input() title:string       = "";
    @Input() subtitle:string    = "";

    constructor(
        private detector : ChangeDetectorRef
    ) { }

    ngOnInit() {
        this.detector.detectChanges();
    }

    hexToRGB(hex, alpha) {        
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);

        if (alpha) {
            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        } else {
            return `rgba(${r}, ${g}, ${b})`;
        }
    }

}
